// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__ZgBb8","total":"Cart_total__mFTGm","actions":"Cart_actions__venrS","button--alt":"Cart_button--alt__nUUHX","button":"Cart_button__c6PLl"};